import { serializeToUrl } from '@/src/lib/filters/filterSerializer';
import type { FilterState } from '@/src/lib/filters/filterTypes';

/**
 * Builds the SRP URL for a given resource + filter state.
 *
 * Used by ListingSearch in `navigate` mode (homepage hero), where filter
 * mutations sit in local draft state until the user clicks Search. The
 * homepage's original ad-hoc 25-line param builder is replaced with the
 * canonical `serializeToUrl` so URLs match the SRP's own serialization.
 */
export function buildSearchUrl(resourceId: string, filters: FilterState): string {
  const basePath = `/${resourceId}/apartments-for-rent`;
  const params = new URLSearchParams(serializeToUrl(filters));
  const qs = params.toString();
  return qs ? `${basePath}?${qs}` : basePath;
}
